import React from "react";
import { X } from "lucide-react";

export const ViewOfferModal = ({ isOpen, onClose, offer }) => {
    if (!isOpen || !offer) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm overflow-y-auto">
            <div className="bg-card border border-border rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto custom-scrollbar">

                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-border">
                    <h3 className="text-lg font-semibold">View Offers</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-black">
                        <X size={20} />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6 space-y-6">

                    {/* Grid: 2 columns */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <Field label="Title" value={offer.title} />
                        <Field label="Code" value={offer.code} />

                        <Field label="Discount Type" value={offer.discountType} />
                        <Field label="Discount Value" value={offer.discountValue} />

                        <Field label="Min Order Value" value={offer.minOrderValue} />
                        <Field label="Max Discount Value" value={offer.maxDiscountValue} />
                        <Field label="Status" value={offer.status} />

                        <Field label="Start Date" value={formatDate(offer.startDate)} />
                        <Field label="End Date" value={formatDate(offer.endDate)} />

                        {/* <Field label="Auto Apply" value={offer.autoApply ? "Yes" : "No"} />
                        <Field label="Draft" value={offer.isDraft ? "Yes" : "No"} /> */}
                    </div>

                    {/* <div>
                        <Field label="Conditions" value={offer.conditions || "—"} />
                    </div> */}

                </div>
            </div>
        </div>
    );
};

// Reusable Field component
const Field = ({ label, value }) => (
    <div>
        <p className="text-sm">{label}</p>
        <p className="text-base font-medium text-gray-500">{value}</p>
    </div>
);

// Date formatter
const formatDate = (date) => {
    try {
        return new Date(date).toLocaleString();
    } catch {
        return date;
    }
};
